import { EProgramType } from './programType';
import { ERealEstateType } from './realEstateType';

export enum EDescriptionType {
  LIST = 'list',
  PARAGRAPH = 'paragraph',
}

interface IParagraphDescription {
  type: EDescriptionType.PARAGRAPH;
  value: string;
}

interface IListDesciption {
  type: EDescriptionType.LIST;
  value: string[];
}

export type TDescription = IParagraphDescription | IListDesciption;

export interface IProgram {
  id: EProgramType;
  name: string;
  description: TDescription;
  shortDescription?: string;
  rate: number;
  creditLimitMillions: number;
  termYears: number;
  isUntilRate?: boolean;
}

export interface IProgramWithPaymentCalculation extends IProgram {
  payment: number;
}

export type TMortgagePrograms = Record<ERealEstateType, IProgram[]>;
